const leafNametreeNode = {
  title: 'ver equipamentos'
};

export default leafNametreeNode;
